import styled from "styled-components";
import { colors } from "design-system";

export const QuestionContainer = styled.div`
  background-color: ${colors.GRAY_LIGHTEST};
  border: 1px solid ${colors.GRAY_LIGHT};
  padding: 24px 16px;
  width: 100%;
`;

export const ErrorContainer = styled.div`
  width: 100%;
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

export const Dot = styled.div`
  background-color: ${props => (props.active ? colors.BRAND : colors.GRAY)};
  border-radius: 50%;
  height: 8px;
  margin-left: 8px;
  width: 8px;

  &:first-child {
    margin-left: 0;
  }
`;
